module.exports = __webpack_public_path__ + "media/images/ball-ada1168a9ed54a1506436e7de3157de5.mp4";